<pw-view-title>BMW PT Lieferantenanbindung</pw-view-title>

<mat-card *ngIf="!environment.production && clientAuth.isAuthenticated$ | async" style="color: red" gdColumns="auto">
  <mat-card-header>
    <mat-icon>warning</mat-icon>
  </mat-card-header>
  <mat-card-content>
    <div style="font-size: 48px">INTEGRATION</div>
  </mat-card-content>
</mat-card>

<div *ngIf="clientAuth.isAuthenticated$ | async; else login">
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{'app.home.welcome' | translate}}!</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      {{'app.home.showOrders' | translate}}.
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-button color="accent" routerLink="/orders">{{'app.home.orders' | translate}}</button>
      <button mat-button color="accent" (click)="logout()">LOGOUT</button>
    </mat-card-actions>
  </mat-card>
</div>

<ng-template #login>
  <pw-login></pw-login>
</ng-template>
